import { render, staticRenderFns } from "./Sustainability.vue?vue&type=template&id=7acbe1f4&scoped=true&"
import script from "./Sustainability.vue?vue&type=script&lang=ts&"
export * from "./Sustainability.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7acbe1f4",
  null
  
)

export default component.exports